import { AcademicUnit, Subject } from "@models/ISchema";
import { AdaptedSubject } from "../models";

export const subjectAdapter = (subject: Subject): AdaptedSubject => {
  const departments = subject?.academicUnits?.filter(
    (au: AcademicUnit) => au?.academicUnitType?.code === "DEP_UF",
  );
  const schools = subject?.academicUnits?.filter(
    (au: AcademicUnit) => au?.academicUnitType?.code === "SCH_UF",
  );

  const subjectWithoutAcademicUnits = { ...subject };
  delete subjectWithoutAcademicUnits.academicUnits;

  return {
    ...subjectWithoutAcademicUnits,
    academicUnits: { departments, schools },
  } as unknown as AdaptedSubject;
};
